import React from 'react';
import styled from 'styled-components/macro';
import { ReactComponent as ChevronRight } from '../images/icons/chevron-right.svg';
import { spacing05 } from '../styling/spacing';

type Props = {
  isExpanded: boolean;
  onClick: () => void;
  className?: string;
  testId?: string;
};

export const ExpandControlChevron = ({ onClick, isExpanded, className, testId }: Props) => {
  return (
    <div onClick={onClick} className={className} data-testid={testId}>
      <ChevronWrapper $isExpanded={isExpanded}>
        <Chevron />
      </ChevronWrapper>
    </div>
  );
};

const ChevronWrapper = styled.div<{ $isExpanded: boolean }>`
  height: ${spacing05};
  width: ${spacing05};
  transition: all 0.25s ease;
  transform: rotate(${props => (props.$isExpanded ? '90deg' : '0deg')});
`;

const Chevron = styled(ChevronRight)`
  height: ${spacing05};
  width: ${spacing05};
  cursor: pointer;
`;
